import React, { useState, useEffect, useRef } from 'react';

const TagSelector = ({ selectedTags, availableTags, onChange }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && 
          !dropdownRef.current.contains(event.target) &&
          !inputRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Filter tags based on search term
  const filteredTags = availableTags.filter(tag => 
    tag.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Check if a tag is selected
  const isTagSelected = (tagId) => {
    return selectedTags.some(tag => tag.id === tagId);
  };

  const handleTagToggle = (tag) => {
    if (isTagSelected(tag.id)) {
      // Remove tag
      onChange(selectedTags.filter(t => t.id !== tag.id));
    } else {
      // Add tag
      onChange([...selectedTags, tag]);
    }
  };

  const handleRemoveTag = (tagId) => {
    onChange(selectedTags.filter(tag => tag.id !== tagId));
  };

  return (
    <div className="tag-selector">
      {/* Selected Tags Display */}
      <div className="mb-2">
        {selectedTags.map(tag => (
          <span key={tag.id} className="badge bg-primary me-2 mb-2">
            {tag.name}
            <button
              type="button"
              className="btn-close btn-close-white ms-2"
              style={{ fontSize: '0.5rem' }}
              onClick={() => handleRemoveTag(tag.id)}
            ></button>
          </span>
        ))}
      </div>

      {/* Tag Search/Selection Dropdown */}
      <div className="dropdown">
        <div className="input-group">
          <span className="input-group-text">
            <i className="bi bi-tags"></i>
          </span>
          <input
            ref={inputRef}
            type="text"
            className="form-control"
            placeholder="Rechercher des tags..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setIsDropdownOpen(true)}
          />
        </div>
        
        {isDropdownOpen && (
          <div 
            ref={dropdownRef}
            className="dropdown-menu show w-100 p-2" 
            style={{ maxHeight: '200px', overflowY: 'auto' }}
          >
            {filteredTags.length > 0 ? (
              filteredTags.map(tag => (
                <div key={tag.id} className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`tag-${tag.id}`}
                    checked={isTagSelected(tag.id)}
                    onChange={() => handleTagToggle(tag)}
                  />
                  <label className="form-check-label" htmlFor={`tag-${tag.id}`}>
                    {tag.name}
                  </label>
                </div>
              ))
            ) : (
              <div className="text-muted text-center py-2">
                Aucun tag trouvé
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TagSelector;